import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const COOKIE_CONSENT_KEY = 'allsecured_cookie_consent';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsent) {
      // Small delay for smoother UX
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
      <div className="cookie-banner-content">
        <p className="cookie-banner-text">
          We use cookies to improve your experience and measure performance. By continuing to use this site, you agree to our{' '}
          <Link to="/cookie-policy">Cookie Policy</Link>.
        </p>
        <div className="cookie-banner-actions">
          <button 
            className="cookie-accept-btn" 
            onClick={handleAccept}
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
